import {
  Component,
  Input,
  Output,
  NgZone,
  Renderer2,
  EventEmitter,
  AfterViewInit,
} from '@angular/core'
import { setFocus } from '@evologi/shared/util-toolkit'
import {
  InputSubmit,
  TrackedBarcodeMode,
} from '@evologi/shared/data-access-api'

@Component({
  selector: 'op-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
})
export class SearchComponent implements AfterViewInit {
  @Input() key = 'search-input'
  @Input() searchClass?: string
  @Input() inputClass?: string
  @Input() searchTerm?: string
  @Input() icon = 'fas fa-search'
  @Input() placeholder = 'Ricerca (min. 3 car.)'

  @Input() autofocus = false
  @Input() autocomplete = true
  @Input() loaded? = false
  @Input() disabled? = false
  @Input() detectSource = false

  // eslint-disable-next-line
  @Output('search') readonly searchEvent: EventEmitter<string> =
    new EventEmitter<string>()
  @Output() readonly searchTermChange: EventEmitter<string> =
    new EventEmitter<string>()
  @Output() readonly searchSubmit = new EventEmitter<InputSubmit>()

  constructor(
    private ngZone: NgZone,
    private renderer: Renderer2,
  ) {}

  ngAfterViewInit() {
    if (this.autofocus) {
      this.focus()
    }
  }

  reset() {
    this.searchTerm = undefined
    this.searchEvent.emit(this.searchTerm)
  }

  search(e?: Event) {
    const term = e ? (e.target as HTMLInputElement).value : this.searchTerm
    this.emitSearch(term)
  }

  onEnter(e: Event): void {
    if (this.detectSource) {
      return
    }
    this.search(e)
  }

  onSourceSubmit(event: InputSubmit): void {
    if (!this.detectSource) {
      return
    }
    this.emitSearch(event.value, event.mode)
  }

  onSearchClick(value: string, mode: TrackedBarcodeMode | undefined): void {
    if (this.detectSource) {
      this.onSourceSubmit({ value, mode })
      return
    }
    this.search()
  }

  focus() {
    setFocus(this.ngZone, this.renderer, `#${this.key}`, 500)
  }

  private emitSearch(
    term?: string,
    mode: TrackedBarcodeMode = 'KEYBOARD',
  ): void {
    if (!term || term === '') {
      this.reset()
      return
    }

    if (term.length < 3) {
      return
    }

    this.searchEvent.emit(term)
    if (this.detectSource) {
      this.searchSubmit.emit({ value: term, mode })
    }
  }
}
